export function dateToFilter(filterDate, filterType) {
  let today = new Date();
  let baseDate = new Date(filterDate);
  let daysOffset = Math.floor((Date.UTC(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / (1000 * 60 * 60 * 24));

  if (filterType === 'end') daysOffset++
  
  return daysOffset.toString() + 'd'
}